/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Input_Text_PlaceholderInputs */



/**
* | output |
* | --- |
* | "What should the agent work on this time?" |
*
* @param {Agent_Run_Input_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_input_text_placeholder = /** @type {((inputs?: Agent_Run_Input_Text_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Input_Text_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Woran soll der Agent diesmal arbeiten?")
	return /** @type {LocalizedString} */ ("What should the agent work on this time?")
});